import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import {
  InfraImageApi,
  TDeleteInfraImageResult,
  TGetInfraImagesResult,
  TSaveInfraImageResult,
} from '../../services';
import { withEnvironment } from '../extensions/with-environment';
import { withRootStore } from '../extensions/with-root-store';
import {
  createInfraImage,
  IInfraImage,
  IInfraImageSnapshot,
  InfraImage,
} from '../infra-image/InfraImage';
import { createPagination, IPagination, IPaginationSnapshot } from '../pagination/Pagination';

/**
 * # InfraImageStore
 *
 * InfraImageStore을 설명하세요.
 */
export const InfraImageStore = types
  .model('InfraImageStore')
  // --------------------------------------------------------------------------
  .props({
    pagination: createPagination(),
    infraImages: types.optional(types.array(InfraImage), []),
    infraImage: createInfraImage(),
  })
  .extend(withEnvironment)
  .extend(withRootStore)
  // eslint-disable-line @typescript-eslint/no-unused-vars
  .views((self) => ({}))
  // --------------------------------------------------------------------------
  // MUTATEs - 모델 상태를 변경
  .actions((self) => ({
    setPagination: (pagination: IPaginationSnapshot) => {
      self.pagination = pagination as IPagination;
    },
    resetPagination: () => {
      self.pagination = { size: 25, page: 1 } as IPagination;
    },
    setInfraImages: (infraImages: IInfraImage[]) => {
      self.infraImages.replace(infraImages);
    },
    setInfraImage: (infraImage: IInfraImage) => {
      self.infraImage = infraImage;
    },
    resetInfraImage: () => {
      self.infraImage = {} as IInfraImage;
    },
  }))
  // --------------------------------------------------------------------------
  // REQUESTs - 서비스 요청 및 기타 인터페이스 요청
  .actions((self) => ({
    gets: async (generate?: 'generate') => {
      const infraImageApi: InfraImageApi = new InfraImageApi(self.environment.api);
      const result: TGetInfraImagesResult = await infraImageApi.gets(generate);
      self.rootStore.responseStore.getResponseResult(result);
      if (result.kind === 'ok') {
        self.setInfraImages(result.infraImages);
        result.pagination && self.setPagination(result.pagination);
      } else {
        console.error(result.kind);
      }
    },
    get: async (imageSid: number) => {
      const infraImageApi: InfraImageApi = new InfraImageApi(self.environment.api);
      const result = await infraImageApi.get(imageSid);
      self.rootStore.responseStore.getResponseResult(result);
      if (result.kind === 'ok') {
        self.setInfraImage(result.infraImage);
      } else {
        console.error(result.kind);
      }
    },
    save: async (infraImage: IInfraImageSnapshot, file?: File) => {
      const infraImageApi: InfraImageApi = new InfraImageApi(self.environment.api);
      const result: TSaveInfraImageResult = await infraImageApi.save(infraImage, file);
      self.rootStore.responseStore.getResponseResult(result);
      if (result.kind === 'ok') {
        self.setInfraImages([
          ...self.infraImages.filter((item) => item.imageSid !== result.infraImage.imageSid),
          result.infraImage,
        ]);
        self.setInfraImage(result.infraImage);
      } else {
        console.error(result.kind);
      }
    },
    delete: async (imageSid: number) => {
      const infraImageApi: InfraImageApi = new InfraImageApi(self.environment.api);
      const result: TDeleteInfraImageResult = await infraImageApi.delete(imageSid);
      self.rootStore.responseStore.getResponseResult(result);
      if (result.kind === 'ok') {
        self.setInfraImages(self.infraImages.filter((item) => item.imageSid !== imageSid));
      } else {
        console.error(result.kind);
      }
    },
  }));

// --------------------------------------------------------------------------
type TInfraImageStore = Instance<typeof InfraImageStore>;
type TInfraImageStoreSnapshot = SnapshotOut<typeof InfraImageStore>;

export interface IInfraImageStore extends TInfraImageStore {}
export type TInfraImageStoreKeys = keyof TInfraImageStoreSnapshot & string;
export interface IInfraImageStoreSnapshot extends TInfraImageStoreSnapshot {}
export const createInfraImageStore = () => types.optional(InfraImageStore, {} as TInfraImageStore);
